import React from 'react';
import styled from 'styled-components/macro';

import { Title } from '../../styled';
import { Flavor } from '../../../../common/types';
import Apple from '../../../../common/components/svg/fruits/Apple';
import Blackberry from '../../../../common/components/svg/fruits/Blackberry';
import Blueberry from '../../../../common/components/svg/fruits/Blueberry';
import Elderflower from '../../../../common/components/svg/fruits/Elderflower';
import Mango from '../../../../common/components/svg/fruits/Mango';
import Pear from '../../../../common/components/svg/fruits/Pear';
import RedRhubarb from '../../../../common/components/svg/fruits/RedRhubarb';
import Watermelon from '../../../../common/components/svg/fruits/Watermelon';

const Wrapper = styled.div(({ $flavor, $active }: {
  $flavor: Flavor,
  $active: boolean
}) => `
  --fruit-inactive: #888;

  padding: 13rem 0;
  width: 100%;

  color: ${$active ? `var(--${$flavor})` : "var(--fruit-inactive)"};
  cursor: pointer;
  border-bottom: 1rem solid #ddd;
  transition: 0.25s color;

  display: flex;
  align-items: center;
  justify-content: start;

  svg {
    margin-right: 10rem;
    flex-shrink: 0;
    transform: translateY(-2rem);
  }
`);

const Banner = ({ onClick, flavor, active, label }: {
  onClick: () => void,
  flavor: Flavor,
  active: boolean,
  label: string
}) => (
  <Wrapper
    onClick={onClick}
    $flavor={flavor}
    $active={active}
  >
    {flavor === "apple" && <Apple active={active} />}
    {flavor === "blackberry" && <Blackberry active={active} />}
    {flavor === "blueberry" && <Blueberry active={active} />}
    {flavor === "elderflower" && <Elderflower active={active} />}
    {flavor === "mango" && <Mango active={active} />}
    {flavor === "pear" && <Pear active={active} />}
    {flavor === "redrhubarb" && <RedRhubarb active={active} />}
    {flavor === "watermelon" && <Watermelon active={active} />}

    <Title>{label}</Title>
  </Wrapper>
);

export default Banner;